<template>
  <div class="rotationSubscription" mb5 xs12 sm12>
    <b-col cols="12" sm="12" md="12" lg="12">
      <b-row mb5>
        <h3>{{ rotation.name }}</h3>
      </b-row>
      <b-row>
        <div class="w-100">
          <b-alert
            :show="dismissCountDown"
            dismissible
            fade
            variant="success"
            @dismiss-count-down="countDownChanged"
          >
            Rotation product has been saved!
          </b-alert>

          <keep-alive>
            <RotatingSubscriptionSkipSlots
              :subscription="subscription"
              :skip-delivery="skipDelivery"
              @selectSlot="selectSlot"
              @view-meals-selection-for-slot="
                (viewSub) => $emit('view-meals-selection-for-slot', viewSub)
              "
            />
          </keep-alive>
        </div>
      </b-row>
    </b-col>

    <rotating-subscription-order-modal
      v-if="selectProductModalFlag"
      v-model="rotation"
      :subscription-object="subscription"
      :vendor_uuid="vendor.uuid"
      :selected-date-time="selectedDateTime"
      @hidden="selectProductModalFlag = false"
    />
    <b-col cols="10" offset="1">
      <hr>
    </b-col>
  </div>
</template>

<script>
import moment from 'moment-timezone';

import RotatingSubscriptionProduct from '@/subscriptions/rotating-subscription-partials/RotatingSubscriptionProducts.vue';
import RotationSubscriptionEditor from '@/subscriptions/rotating-subscription-partials/RotatingSubscriptionEditor.vue';
import RotatingSubscriptionSkipSlots from '@/subscriptions/rotating-subscription-partials/RotatingSubscriptionSkipSlots.vue';

import SmallSpinner from '@/common/SmallSpinner.vue';

import { mapGetters } from 'vuex';
moment.locale('en-CA');

import { getSubscriptionById } from './rotating-subscription-service';
import RotatingSubscriptionOrderModal from '@/subscriptions/rotating-subscription-partials/RotatingSubscriptionOrderModal.vue';

export default {
  name: 'RotationSubscription',
  components: {
    SmallSpinner,
    RotatingSubscriptionOrderModal,
    RotatingSubscriptionProduct,
    RotationSubscriptionEditor,
    RotatingSubscriptionSkipSlots,
  },
  props: {
    rotation: { type: Object, default: null },
    subscription: { type: Object, default: null },
  },
  data: () => {
    return {
      skipDelivery: false,
      deliveryOptions: [
        { text: 'Skip delivery', value: false },
        { text: 'Select day', value: true },
      ],
      subscription_data: Object,
      selectProductModalFlag: false,
      selectedProducts: [],
      loading: false,

      skipAllDeliverySlots: [],
      skipDeliverySlots: [],
      skipSlotLoading: false,
      skipSlot: null,
      deleteSlot: null,
      selectedDateTime: '',

      dismissSecs: 5, // Time in seconds for b-alert show
      dismissCountDown: 0,
      showDismissibleAlert: false,
    };
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    ...mapGetters(['vendor', 'region']),
  },

  watch: {},
  mounted() {},
  methods: {
    async fetchData() {
      this.subscription_data = await getSubscriptionById(
        this.rotation.subscription_id
      );
    },

    selectSlot(slotDateTime) {
      this.selectedDateTime = slotDateTime;
      this.selectProductModalFlag = true;
    },

    submit() {
      let data = {};

      data.products = this.selectedProducts;
    },

    handleRotationModalUpdate(newValue, type = '') {
      this.selectProductModalFlag = newValue;
      if (type) {
        this.dismissCountDown = this.dismissSecs;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    handleSelectedProducts(selectedProducts) {
      // Get selected products from child component
      this.selectedProducts = selectedProducts;
    },
    fetchRotation() {
      this.loading = true;
      fetchRotatingSubscription(this.uuid)
        .then((response) => {
          this.rotation = response;
          this.loading = false;
        })
        .catch((error) => {
          this.$store.dispatch('alertError', ['danger', error.message]);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/variables.module';
@include inputs;

@include buttons;

.rotationSubscription {
  margin-bottom: 15px;
}
</style>
